import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';

import Grid from '@material-ui/core/Grid';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelActions from '@material-ui/core/ExpansionPanelActions';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Chip from '@material-ui/core/Chip';
import Button from '@material-ui/core/Button';
import Divider from '@material-ui/core/Divider';
import TextField from '@material-ui/core/TextField';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import MenuItem from '@material-ui/core/MenuItem';

import SonicEditor from './SonicEditor'


const styles = theme => ({
  root: {
    width: '100%',
  },
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
  },
  button: {
    marginRight:  theme.spacing.unit,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: 200,
  },
  icon: {
    verticalAlign: 'bottom',
    height: 20,
    width: 20,
  },
  details: {
    alignItems: 'center',
  },
  columnEditor: {
    flexBasis: '80%',
  },
  columnHelper: {
    flexBasis: '20%',
  },
  helper: {
    borderLeft: `2px solid ${theme.palette.divider}`,
    padding: `${theme.spacing.unit}px ${theme.spacing.unit * 2}px`,
  },
  link: {
    color: theme.palette.primary.main,
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 120,
  },
});



const lastResultCodes = [
    {name: 'APPT', color: '#036daf'},
    {name: 'Contacted', color: '#0089ba'},
    {name: 'Follow Up', color: '#06aa8f'},
    {name: 'Incorrect Person', color: '#ad03a4'},
    {name: 'DNC', color: '#757575'},
    {name: 'DNQ', color: '#ad0505'},
    {name: 'Give Up', color: '#b75e00'},
    {name: 'NI/Covered', color: '#a9055a'},
    {name: 'No_Contact', color: '#c63f81'},
    {name: 'Retry___', color: '#cc9502'},
    {name: 'SOLD', color: '#00af1a'},
    {name: 'Spanish', color: '#a3690d'},
    {name: 'Transfer', color: '#6b6b6b'},
    {name: 'Non-Working Number', color: '#ad03a4'},
]



class SonicAction extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
         panelOpened: false,
          isEditing: false,
          comment: ''
         }
    }
    componentDidMount(){
        const { comment } = this.props
        this.setState({comment})
    }
    updateComment = (comment) => {
        this.setState({comment})
   
       // updateItem({id, type: 'comment', value: comment})
    }
    makeEditor = () => {
        const { comment } = this.state
        return (
            <SonicEditor placeholder={'Write something...'} htmlContent={comment} update={this.updateComment}/>
        )
    }
    makeSummaryString = () => {
       const { comment, cellSize } = this.props

       if(comment){
        const noHTML = comment.replace(/<[^>]+>/g, '')
        let lastIndex = 20
        if(cellSize > 6){
            lastIndex = noHTML.length > 100 ? 100 : noHTML.length
        }else{
            lastIndex = noHTML.length > 50 ? 50 : noHTML.length
        }
    
        return noHTML.substring(0, lastIndex)
       }
        return 'Make a comment'
    }
    makeLastResultCodes = () => {

        const arrayOfOptions = lastResultCodes.map(resultCode => {
            const { name, color } = resultCode
            return (
                <option key={name} value={name} >{name}</option>
            )
        })

        arrayOfOptions.unshift(<option  key={'none'} value="None Selected" />)

        return arrayOfOptions

    }
    makeOpenHeader = () => {


    }
    makeClosedHeader = () => {
        
    }
    openEditor = () => {
        this.setState({panelOpened: true})

    }
    saveEditor = () => {
        const { comment } = this.state
        const { id, updateItem } = this.props
        updateItem({id, type: 'comment', value: comment})
        this.setState({panelOpened: false})
    }
    closeEditor = () => {
        this.setState({panelOpened: false})
    }
    clickComment = event => {
       console.log(event)
       /* const { panelManuallyOpened, comment } = this.state
        const { comment: currentComment } = this.props
        const tempUpdate = {panelManuallyOpened: !panelManuallyOpened}
        if(panelManuallyOpened){
            if(comment !== currentComment){
                tempUpdate.showCommentSaveDialog = true
            }
        }
        this.setState(tempUpdate)*/
    }
    render() {
        const { isEditing, panelOpened } = this.state
        const { classes, lastResult, updateItem, id, cellSize } = this.props

        /*
        let borderColor = '#FFFFFF'
        if(lastResult in lastResultCodes){
            borderColor = lastResult
        }*/

        return (
            <div className={classes.root}>
            <ExpansionPanel expanded={panelOpened} onChange={this.clickComment}>
                <ExpansionPanelSummary style={{paddingRight:0}}>
                {panelOpened ? null : 
                    <Grid item container>
            
                    <Grid item container item xs={6} spacing={24} direction="row" alignItems="center" justify="flex-start" > 
                            <Grid item xs={2}>
                                <Button  size="small" onClick={this.openEditor} variant="outlined" color="primary" >Notes</Button>
                            </Grid>
                            <Grid item xs={10}>
                                {cellSize > 6  ? <Typography noWrap align="left" className={classes.secondaryHeading}>{this.makeSummaryString()}</Typography> : null}
                            </Grid>
                    </Grid>
             
                    
                    <Grid item container item xs={6} direction="row" alignItems="center" justify="flex-end">
                

                    <FormControl className={classes.formControl}>
                    <InputLabel htmlFor="lastResult-native-required">Last Result</InputLabel>
                    <Select
                      native
                      style={{minWidth: 100}}
                      value={lastResult ? lastResult : ''}
                      onChange={(event) => updateItem({id, type: 'lastResult', value: event.target.value})}
                      name="lastResult"
                      inputProps={{
                        id: 'lastResult-native-required',
                      }}
                     
                    >
                      {this.makeLastResultCodes()}
                    </Select>
                  </FormControl>


                  
              
                    
                    </Grid> 
                    </Grid>        
          
                
                }
              
                </ExpansionPanelSummary>
                <ExpansionPanelDetails className={classes.details}>
                
                <Grid item container>
            
                <Grid item container item xs={12} direction="row" alignItems="center" justify="space-between"> 
                
                <Grid item xs={'auto'}>
                <div className={classes.columnEditor}>
                    {this.makeEditor()}
                </div>
                </Grid>
               {/* <Grid item xs={'auto'}>
                <div className={classNames(classes.columnHelper, classes.helper)}>
                <form className={classes.container} noValidate>
                <TextField
                  id="datetime-local"
                  label="Next appointment"
                  type="datetime-local"
                  defaultValue="2017-05-24T10:30"
                  className={classes.textField}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </form>
                </div>
                </Grid>*/}
                </Grid>
                </Grid>




                </ExpansionPanelDetails>
                <Divider />
                <ExpansionPanelActions>
                <Button size="small" onClick={this.closeEditor} >Cancel</Button>
                <Button size="small" onClick={this.saveEditor} color="primary">
                    Save
                </Button>
                </ExpansionPanelActions>
            </ExpansionPanel>

            </div>
        );
}
}

SonicAction.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(SonicAction);


// WEBPACK FOOTER //
// ./src/components/lib/SonicAction.js